import { calculateTierPoints } from "@/helpers/yotpoHelper";
import { openAccountSidebar } from "@/redux/actions/loggedInUser";
import { openMiniCart } from "@/redux/actions/addToCartAction";
import { generalConstants } from "@/utils/constants";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styles from "../YotpoTierPoints/yotpoPoints.module.scss";
import { useRouter } from "next/compat/router";
import Link from "next/link";
import { setCookie } from "cookies-next";
import { getNumberId } from "@/helpers/wishlistHelpers";
import { isGuest } from "@/redux/actions/pwaAction";

function YotpoTierPoints({ price, product_id, isBorder, compClass, isBag=false,isPDP }) {
  // get the state if the user is logged in to pass to yotpo customer identification 
  // to update the points based on tier
  let logUser = useSelector((state) => state.loginUser);
  const userLoggedIn = logUser.userLoggedIn;
  const userId = logUser.userData?.id;
  let customer = logUser?.userData;
  let customerId;
  if (userId) {
    const cId = Buffer.from(userId, "base64").toString("ascii");
    customerId = getNumberId(cId);
  }
  const isBagOpen = useSelector((state) => state.click.open_mini_cart);
  const [isYourBagPage, setIsYourBagPageOpen] = useState(false);
  const[yotpoImage,setYotpoImage]=useState();
  const dispatch = useDispatch();
  const router = useRouter();
  const logedIn = useSelector((state) => state.loginUser);
  const tier = logedIn?.yotpoDetails;
  let calculateTierPointsTotal = calculateTierPoints(price,tier);
  //convert dollars to cents to pass the price in the yotpo script 
  const priceInCents = (parseFloat(price) * 100).toString();
  useEffect(() => {
    if (router.asPath.includes("/your-bag")) {
      setIsYourBagPageOpen(true);
    }
  },[router])

    useEffect(() => {
      if(userLoggedIn){
        let yotpoData = {};
          if (typeof window !== "undefined") {
            if(sessionStorage.getItem("yotpo_info")){
              const storedData=sessionStorage.getItem("yotpo_info")
              if (storedData) {
                yotpoData=JSON.parse(storedData);
              }
            } else {
              //SUP-2733 : this condition checks logedIn.yotpoDetails, so it gets processed when yotpoDetails is fetched
              //avoiding page crash when yotpoDetails is undefined
              if (tier) {
                sessionStorage.setItem("yotpo_info", JSON.stringify(tier));
                yotpoData = JSON.parse(JSON.stringify(tier));
              }
            }
          }
            if(generalConstants.yotpo_tier_names[yotpoData?.vip_tier_name?.toLowerCase()]===1){
              setYotpoImage(generalConstants.yotpo_doller_image_one);
           }
           else if(generalConstants.yotpo_tier_names[yotpoData?.vip_tier_name?.toLowerCase()]===2){
             setYotpoImage(generalConstants.yotpo_doller_image_two)
           }
           else if(generalConstants.yotpo_tier_names[yotpoData?.vip_tier_name?.toLowerCase()]===3){
             setYotpoImage(generalConstants.yotpo_doller_image_three)
           } else {
              setYotpoImage(generalConstants.yotpo_doller_image) //If no tier is present then take the default value for icon
           }
      }else{
        sessionStorage.removeItem("yotpo_info");
        setYotpoImage(generalConstants.yotpo_doller_image)
      }
    }, [userLoggedIn])


    
    return (
      <div className={`${styles.yotpo_tier_points} ${isBorder?"border":""} ${compClass}`}>
        {/* based on the tier levels the yotpo image will change and if user not logged in then it will display default yotpo image*/}
        {!isPDP &&
           (<img className={styles.doller_icon} src={yotpoImage} alt="doller"/>
         )}
          {
            // Display generic message only on bag and your-bag, !isPDP is set to not affect the PDP message
            // usercheckLoggedIn check is added to display message on the cart and your-bag acc.
            !isPDP && (isBagOpen||isYourBagPage) && (
            !userLoggedIn?
            <>
            <span className={`xx-small-xs x-small-sm x-small-md ${styles.reward_message}`}>
              <a
                //  if user using PWA and not using it for the first time then setting guest state to false
                onClick={() => { dispatch(openAccountSidebar(true)); dispatch(openMiniCart(false)); setCookie("redirect_path", "/your-bag", { maxAge: 60 * 2 }); setCookie("hide_signin_cross", true); dispatch(isGuest(false)) }}
                >
                <span className="hover" tabIndex={0}>Sign in</span>
              </a> to earn and spend reward points
            </span>
              </> 
            :
            <Link tabIndex={0} onClick={()=>{dispatch(openMiniCart(false))}}  href="/rewards">   
              <span className={`xx-small-xs x-small-sm x-small-md ${styles.pl_5}`}>
                You will earn reward points on your purchase
              </span>
            </Link>
            )
          }
          {/* Yotpo customer identification script - added to change the points based on customer tier*/}
          {/* {
            userId && 
            <div id="swell-customer-identification" data-authenticated="true"
              data-email={customer.email}
              data-id={customerId}
              data-tags={JSON.stringify(customer.tags)}
              style={{ display: 'none' }}>
            </div>
          } */}
          {/* Points based on campaigns and tiers through yotpo script */}
          {
            isPDP && userLoggedIn && <a href="/rewards" tabIndex={0}>
            <p className={`xx-small-xs x-small-sm x-small-md swell-product-wrapper auto-yotpo-pdp ${styles.reward_message}`}>
              <span>As a Rewards member you earn</span>&nbsp;<span 
                className="swell-product-helper"
                data-mode="display-points"
                data-product-id={product_id}
                data-price-cents={priceInCents}>{calculateTierPointsTotal? calculateTierPointsTotal : ''}</span>&nbsp;<span>points with this purchase</span>
              <img className={styles.doller_icon} src={yotpoImage} alt="doller"/>
            </p>
            </a>
          } 
          {
            isPDP && !userLoggedIn && <a href="/rewards" tabIndex={0}>
            <p className={`xx-small-xs x-small-sm x-small-md swell-product-wrapper auto-yotpo-pdp ${styles.reward_message}`}>
              <span>Rewards members earn</span>&nbsp;<span 
                className="swell-product-helper"
                data-mode="display-points"
                data-product-id={product_id}
                data-price-cents={priceInCents}>{calculateTierPointsTotal? calculateTierPointsTotal : ''}</span>&nbsp;<span>points with this purchase</span>
              <img className={styles.doller_icon} src={yotpoImage} alt="doller"/>
            </p>
            </a>
          }
      </div>
    )
  }

  export default YotpoTierPoints